import React, { FC, useState } from 'react';
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input';
// `react-phone-number-input` doesn't ship the country flag SVGs by
// default — without this `flags` prop the country selector renders a
// broken-image placeholder (see icon next to the dial code).
import flags from 'react-phone-number-input/flags';
import './style.css';

interface CountryPhoneInputProps {
  name?: string; // Optional name prop
  value?: string; // Controlled value
  onChange?: (value: string) => void; // Handler for when the value changes
}

const CountryPhoneInput: FC<CountryPhoneInputProps> = ({ name, value, onChange }) => {
  const [internalValue, setInternalValue] = useState<string | undefined>(value);

  // Update internal state and propagate change to parent component if onChange is provided
  const handleChange = (value: string | undefined) => {
    setInternalValue(value); // Update internal state
    if (onChange && value) onChange(value); // Propagate change to parent component
  };

  return (
    <div className="flex items-center border border-gray-300 rounded-2xl overflow-hidden">
      <PhoneInput
        international
        defaultCountry="US"
        value={internalValue}
        onChange={handleChange} // Handle change internally and call parent handler
        flags={flags}
        className="flex-1"
        style={{ padding: "0 0px 0 16px"}}
      />
    </div>
  );
};

export default CountryPhoneInput;
